export class GlobalCleanupConfigurationInfoView {
  public isProcessEnabled: boolean;
  public lastExecutionDate: Date;
  public retentionMonths: number;
  public dayOfTheMonth: number;
  public dayOfTheWeek: string;
  public timeExecution: Date;
  public sTimeExecution: string;
}
